/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";
import { ButtonComponent } from "../../shared/components/button/button.component";

@Component({
	selector: "globalictcc-error",
	standalone: true,
	imports: [ButtonComponent],
	templateUrl: "./error.component.html",
	styleUrl: "./error.component.scss"
})
export class ErrorComponent {
	public onRetry() {
		window.location.href = "/";
	}
}
